import React from "react";
import { motion, useAnimation, useInView } from "framer-motion";

// Reveal helper animates in when visible and out when leaving viewport
export function Reveal({
    children,
    from = { opacity: 0, y: 24 },
    to = { opacity: 1, y: 0 },
    className = "",
}) {
    const ref = React.useRef(null);
    const controls = useAnimation();
    const inView = useInView(ref, { margin: "-10% 0px -10% 0px" });

    React.useEffect(() => {
        if (inView)
            controls.start({ ...to, transition: { duration: 0.6, ease: "easeOut" } });
        else
            controls.start({
                ...from,
                transition: { duration: 0.45, ease: "easeIn" },
            });
    }, [inView]);
    return (
        <motion.div
            ref={ref}
            initial={from}
            animate={controls}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export const Section = ({ id, className = "", children }) => (
    <section id={id} className={`w-full py-20 md:py-28 ${className}`}>
        {children}
    </section>
);

export const Container = ({ className = "", children }) => (
    <div className={`mx-auto w-full max-w-7xl px-4 sm:px-6 relative z-10 ${className}`}>
        {children}
    </div>
);

export const EyebrowLarge = ({ children, className = "" }) => (
    <div
        className={`font-heading text-[32px] md:text-[62px] font-extrabold tracking-[0.22em] text-transparent bg-clip-text bg-gradient-to-b from-white to-white/60 drop-shadow-sm ${className}`}
    >
        {children}
    </div>
);
